import { Context, CustomQuery } from '@vue-storefront/core';
import { Cart, CartItem, ApiResult } from '../../types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function customCartLoad({ client, config }: Context, parms: CustomQuery): Promise<ApiResult> {

  const url = new URL('/mall/cart/get', config.api.url);

  const { data: res } = await client.post(url.href, parms);
  if (res.code === 0) {
    const data = res.data;
    const allCart: Cart = {
      list: [],
      total: data.total_count,
      setType: data.set_type
    };

    if (data && data.data) {
      // 循环list
      data.data.forEach((item) => {
        const cart: CartItem = {
          createTime: item?.create_time,
          goodId: item?.good_id,
          id: item?.id,
          image: item?.img_url,
          memberId: item?.member_id,
          num: item?.num,
          offShelves: item?.off_shelves,
          price: item?.price,
          properties: item?.properties,
          shopId: item?.shop_id,
          skuId: item?.sku_id,
          stockShortage: item?.stock_shortage,
          title: item?.title,
          discountPrice: item?.discount_price
        };
        allCart.list.push(cart);
      });
    }
    res.data = allCart;
  }
  return res;
}
